import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export default function DefaultDeleteDialog({ open, onClose, onConfirm, entityName = "item" }) {

    const handleConfirm = async () => {
        if (onConfirm) {
            await onConfirm()
        }
        onClose()
    }

    return (
        <Dialog open={open} keepMounted onClose={onClose} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>{"Remover"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {`Deseja realmente remover este ${entityName}?`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirm}>
                    Confirmar
                </Button>
                <Button onClick={onClose}>
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
